export const COURSE_OPTIONS = [
  'PDPA Awareness Training',
  'HR PDPA Awareness Training',
  'PDPA for SME',
  'PDPA for DPO',
] as const
